export const language = [
	{ id: "60221e4c5416132910ef4437", value: "en", label: "English" },
	{ id: "60221e935416132910ef4438", value: "fr", label: "French" },
	{ id: "6316cf4e7549e806e8b53086", value: "ar", label: "Arabic" }
];
